import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d24ec12c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d24ec12c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24ec12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24ec12c')) {
      api.createRecord('d24ec12c', component.options)
    } else {
      api.reload('d24ec12c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d24ec12c&scoped=true", function () {
      api.rerender('d24ec12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/behavior/index.vue"
export default component.exports